export const RUNSHEET_HEADERS = [
    { id: 'document.name', label: 'Document', defaultChecked: false },
    { id: 'grantors', label: { deed: 'Grantor', lease: 'Lessor' }, defaultChecked: true },
    { id: 'grantees', label: { deed: 'Grantee', lease: 'Lessee' }, defaultChecked: true },
    { id: 'fullGrantor', label: { deed: 'Full Grantor', lease: 'Full Lessor' }, defaultChecked: false },
    { id: 'fullGrantee', label: { deed: 'Full Grantee', lease: 'Full Lessor' }, defaultChecked: false },
    { id: 'bookType', label: 'Book Type', defaultChecked: true },
    { id: 'bookVolume', label: 'Book Volume', defaultChecked: true },
    { id: 'bookPage', label: 'Page', defaultChecked: true },
    { id: 'instrumentNumber', label: 'Instrument #', defaultChecked: true },
    { id: 'instrumentType', label: 'Instrument Type', defaultChecked: true },
    { id: 'instrumentDate', label: 'Instrument Date', defaultChecked: true },
    { id: 'fileDate', label: 'File Date', defaultChecked: true },
    { id: 'legalDescriptions', label: 'Legal Description', defaultChecked: true },
    { id: 'comment', label: 'Comment', defaultChecked: true },
    { id: 'recordingDate', label: 'Recording Date', defaultChecked: false },
    { id: 'notes', label: 'Notes', defaultChecked: false },
    
]

export const RUNSHEETS_HEADERS = {
    'Runsheet Name': { key: 'name', sortable: true, dataSort: 'name' },
    'Number of Documents': { key: 'numberOfDocuments', sortable: false },
    'Assigned To': { key: 'assignedTo', sortable: true, dataSort: 'assigned' },
    'Status': { key: 'status', sortable: true, dataSort: 'status' },
    'Status Date': { key: 'statusDate', sortable: true, dataSort: 'statusDate' },
    'Cert. Date': { key: 'certDate', sortable: true, dataSort: 'cert_date' },
}

export const PARTY_CASING = {
    'none': 'Original',
    'upper': 'Upper',
    'proper': 'Standard',
}

export const NUMBER_DISPLAY_TYPE = {
    PERCENT: 'percent',
    DECIMAL: 'decimal',
}

export const MAIN_TAB = '0'

export const TAB_TYPE_DEED = 'deed'

export const TAB_TYPE_LEASE = 'lease'